// extracted by mini-css-extract-plugin
module.exports = {"card":"card_card__259L6","image":"card_image__1_QQF","info":"card_info__10gaE","title":"card_title__htQKx","container":"card_container__3TO_F"};